//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { createRefetchContainer } from "react-relay";

// suggestion-body-autopilot imports
import { IProps, IContainer, IState } from "./SuggestionBodyAutopilot.d";
import { suggestionBodyAutopilotFragments, refetchQuery } from "./SuggestionBodyAutopilot.gql";
import * as s from "./SuggestionBodyAutopilot.styles";
// other components
import { H3 } from "@ui";
import { AvatarPerson } from "@components/avatar";
// util
import { nonRoomCalendarIds, niceRooms, removeAutopilotEmoji } from "@util/event.util";
import { EFlex } from "@util/event-tag.util";
import {
  getEventTime,
  getAutopilotTime,
} from "@clockwise/client-commons/src/util/event-recurrence";
// material-ui
import { Autorenew, Assistant, Domain } from "@material-ui/icons";

//////////////////
// COMPONENT
//////////////////
class SuggestionBodyAutopilotCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      persons: [],
    };
  }

  public componentDidMount() {
    // load persons for avatars
    const attendeeCalIds = nonRoomCalendarIds(this.props.suggestionPayload.targetEvent.attendees);
    this.props.relay.refetch(
      {
        calendarIds: attendeeCalIds,
        orgRelayId: this.props.org.id,
      },
      undefined,
      () => {
        if (this.props.org.personsByCalendarIdsErrorable.__typename === "PersonList") {
          const persons = this.props.org.personsByCalendarIdsErrorable.list;
          this.setState({ persons });
        }
      },
    );
  }

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-
  public render() {
    const { autopilotOptions, suggestionPayload, org } = this.props;
    const { targetEvent } = suggestionPayload;
    const { persons } = this.state;
    const flex = autopilotOptions ? autopilotOptions.flex : EFlex.Day;
    const title = removeAutopilotEmoji(targetEvent.title);
    // room stuff
    const roomsList = niceRooms(targetEvent.attendees, 15);
    const roomFlexAllowed = autopilotOptions ? autopilotOptions.allowSimilarRooms : false;
    const roomSentence = !!roomsList && roomFlexAllowed ? "Best available room" : roomsList;
    const roomIconStyle = roomFlexAllowed ? s.iconPrimary : s.icon;
    const roomTextStyle = roomFlexAllowed ? s.textRoomPrimary : s.textRoom;

    return (
      <div style={s.container}>
        <H3>{title}</H3>
        <div style={s.infoContainer}>
          <div style={s.row}>
            <Assistant {...s.iconPrimary} />
            <div style={s.textAutopilot}>Flexible meeting</div>
          </div>
          <div style={s.row}>
            <Autorenew {...s.iconPrimary} />
            <div style={s.textPrimary}>{getAutopilotTime(targetEvent, flex)}</div>
          </div>
          <div style={s.row}>
            <div style={s.icon.style} />
            <div style={s.textRevised}>{getEventTime(targetEvent)}</div>
          </div>
          {!!roomSentence && (
            <div style={s.row}>
              <Domain {...roomIconStyle} />
              <div style={roomTextStyle}>{roomSentence}</div>
            </div>
          )}
        </div>
        <div style={s.row}>
          {persons.map((person) => {
            return (
              <AvatarPerson
                org={org}
                person={person}
                orgPerson={null}
                style={s.avatar}
                key={person.primaryEmail}
                size={36}
                backupCalendarId={person.primaryEmail}
                parentName={"SuggestionBodyAutopilot"}
              />
            );
          })}
        </div>
      </div>
    );
  }
}

//////////////////
// RELAY
//////////////////
export const SuggestionBodyAutopilot = createRefetchContainer<IContainer>(
  SuggestionBodyAutopilotCmpt,
  suggestionBodyAutopilotFragments,
  refetchQuery,
);
